import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import { ClientTypeSelect } from './components/ClientTypeSelect';
import { StatusSelect } from './components/StatusSelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './CustomersControlPanel.module.scss';

const CustomersControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<ClientTypeSelect />
				<StatusSelect />
				<ResetBtn />
				<div className={style.verticalAlignBlock}>
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default CustomersControlPanel;
